const reducer = (state = 'All', action) =>{
    switch(action.type){
        case "setWorkflowType": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  